export const useShopifyListTableStyles = () => {
  return {
    // Container styles
    container: {
      width: '100%',
      backgroundColor: '#FFFFFF',
      borderRadius: '8px',
      pt: '21px',
    },

    // Header styles
    tableHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      pb: '9px',
    },

    headerLeft: {
      display: 'flex',
      alignItems: 'center',
    },

    headerTitle: {
      fontFamily: 'Lexend',
      fontSize: '16px',
      fontWeight: 400,
      color: '#000000',
    },

    headerRight: {
      display: 'flex',
      alignItems: 'center',
    },

    selectionCount: {
      fontFamily: 'Lexend',
      fontSize: '16px',
      color: '#000000',
      fontWeight: 400,
    },

    // Table wrapper for horizontal scroll
    tableWrapper: {
      position: 'relative',
      overflowX: 'auto',
      '&::-webkit-scrollbar': {
        height: '8px',
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: '#F5F5F5',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#C1C1C1',
        borderRadius: '4px',
        '&:hover': {
          backgroundColor: '#A8A8A8',
        },
      },
      '@media (max-width: 1024px)': {
        overflowX: 'auto',
      },
      '@media (max-width: 768px)': {
        overflowX: 'auto',
      },
    },

    tableHeaderCell: {
      fontFamily: 'Lexend',
      fontSize: '12px',
      fontWeight: 400,
      color: '#959595',
      borderBottom: '2px solid #E0E0E0',
      padding: '0px 8px 0px 0px',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      whiteSpace: 'nowrap',
    },

    tableCell: {
      padding: '12px 8px 12px 0px',
      borderBottom: '1px solid #CBCBCB',
      fontFamily: 'Lexend',
      fontSize: '14px',
      color: '#333333',
      whiteSpace: 'nowrap',
    },

    // Checkbox styles
    checkbox: {
      fontSize: '20px',
      ml: '8px',
      pl: '8px',
      pr: '8px',
      color: '#BFBFBF !important',
      '&.Mui-checked': {
        color: '#0F0F0F !important',
        fill: '#0F0F0F !important',
      },
      '&.MuiCheckbox-indeterminate': {
        color: '#0F0F0F !important',
        fill: '#0F0F0F !important',
      },
      '& .MuiSvgIcon-root': {
        fontSize: '20px',
      },
    },

    checkboxDisabled: {
      fontSize: '20px',
      ml: '8px',
      pl: '8px',
      pr: '8px',
      color: '#BFBFBF',
      '&.Mui-checked': {
        color: '#959595',
      },
      '&.MuiCheckbox-indeterminate': {
        color: '#959595',
      },
      '& .MuiSvgIcon-root': {
        fontSize: '20px',
      },
    },

    // Product name cell
    productNameCell: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: 1,
    },

    productNameText: {
      maxWidth: 150,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: 4,
      WebkitBoxOrient: 'vertical',
      lineHeight: '1.2',
      fontFamily: 'Lexend',
      fontSize: '12px',
      color: '#0F0F0F',
      fontWeight: 400,
      whiteSpace: 'normal',
    },

    // Description cell
    descriptionText: {
      maxHeight: '115px',
      maxWidth: 166,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: 5,
      WebkitBoxOrient: 'vertical',
      lineHeight: '1.2',
      fontFamily: 'Lexend',
      fontSize: '14px',
      color: '#0F0F0F',
      whiteSpace: 'normal',
    },

    // Tags container
    tagsContainer: {
      minWidth: '100px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: 0.5,
    },

    tagChip: {
      padding: '2px 5px 2px 0px',
      borderRadius: '12px',
      fontSize: '12px',
      color: '#0F0F0F',
      fontWeight: 400,
      fontFamily: 'Lexend',
    },

    moreTagsText: {
      fontSize: '10px',
      fontWeight: 400,
      color: '#000000',
      fontFamily: 'Lexend',
      borderRadius: '50%',
      height: '19px',
      width: '19px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#F0F0F0 !important',
    },

    // Status styles
    statusActive: {
      color: '#0F0F0F',
      fontSize: '12px',
      fontWeight: 400,
      fontFamily: 'Lexend',
      textTransform: 'capitalize',
    },

    // Images container
    imagesContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: 0.5,
    },

    productImage: {
      width: 40,
      height: 40,
      objectFit: 'cover',
      borderRadius: 4,
    },

    smallImage: {
      width: 40,
      height: 40,
      objectFit: 'contain',
      borderRadius: 2,
      border: '0.62px solid #CBCBCB',
      backgroundColor: '#F9F9F9',
    },

    moreImagesBox: {
      width: 19,
      height: 19,
      backgroundColor: '#F5F5F5',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      fontSize: '10px',
      fontWeight: 400,
      color: '#000000',
      fontFamily: 'Lexend',
    },

    // Expand button
    expandButton: {
      color: '#1243B5',
      '&:hover': {
        backgroundColor: 'rgba(18, 67, 181, 0.1)',
      },
    },

    // Variant table styles
    variantTableContainer: {
      maxWidth: '50%',
      borderRadius: '4px',
      ml: '20px',
      mb: '10px',
    },

    variantTable: {
      borderRadius: '4px',
    },

    variantTableHeader: {
      fontFamily: 'Lexend',
      fontSize: '10px',
      fontWeight: 400,
      color: '#959595',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
    },

    variantTableCell: {
      fontFamily: 'Lexend',
      fontSize: '14px',
      color: '#333333',
    },

    // Color indicator
    colorIndicator: {
      width: 20,
      height: 20,
      borderRadius: '50%',
      border: '1px solid #ddd',
      display: 'inline-block',
      marginRight: '8px',
    },

    // Pagination styles
    paginationContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '16px 24px',
      '@media (max-width: 768px)': {
        flexDirection: 'column',
        gap: '16px',
        alignItems: 'flex-start',
      },
    },

    pagesize: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      fontFamily: 'Lexend',
      fontSize: '14px',
      color: '#666666',
    },

    showingText: {
      fontFamily: 'Lexend',
      fontSize: '14px',
      color: '#666666',
    },

    ofText: {
      fontFamily: 'Lexend',
      fontSize: '14px',
      color: '#666666',
    },

    showSelect: {
      minWidth: 80,
      '& .MuiOutlinedInput-root': {
        fontFamily: 'Lexend',
        fontSize: '14px',
        height: '32px',
      },
      '& .MuiSelect-select': {
        padding: '4px 8px',
        display: 'flex',
        alignItems: 'center',
      },
    },

    pagination: {
      '& .MuiPaginationItem-root': {
        fontFamily: 'Lexend',
        fontSize: '14px',
        color: '#666666',
        border: '1px solid #E0E0E0',
        '&.Mui-selected': {
          backgroundColor: '#1243B5',
          color: '#FFFFFF',
          borderColor: '#1243B5',
          '&:hover': {
            backgroundColor: '#0F36A0',
          },
        },
        '&:hover': {
          backgroundColor: '#F5F5F5',
        },
      },
      '@media (max-width: 768px)': {
        '& .MuiPagination-ul': {
          justifyContent: 'center',
        },
      },
    },

    // Dropdown styles for table cells
    dropdownCell: {
      '& .MuiSelect-root': {
        fontSize: '12px',
        fontFamily: 'Lexend',
        color: '#0F0F0F',
        '& .MuiSelect-select': {
          padding: '4px 8px',
        },
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          border: 'none',
        },
        '&:hover fieldset': {
          border: 'none',
        },
        '&.Mui-focused fieldset': {
          border: 'none',
        },
      },
    },
  };
}; 